import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectContextCore } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AlliancesService {
  private alliances = ['superclub', 'davivienda'];
  private isBrandAlliance: boolean;

  constructor(private store$: Store<IHotelsAppState>) {
    this.store$
      .pipe(select(selectContextCore))
      .pipe(take(1))
      .subscribe((context) => {
        this.isBrandAlliance = this.alliances.includes(context.brand);
      });
  }

  public isAlliance(): boolean {
    return this.isBrandAlliance;
  }
}
